<script>
import InputDefault from "@/components/Global/InputDefault.vue";
import useValidate from "@vuelidate/core";
import {cardValidation} from "@/validation/Card";
import TooltipCvv from "@/components/Global/TooltipCVV.vue";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import CheckBox from "@/components/Global/CheckBox.vue";
import axiosInstance from "@/helpers/axios";

export default {
  name: "AddNewCardModal",
  components: {CheckBox, ButtonPrimary, TooltipCvv, InputDefault},
  data() {
    return {
      cardNumber: "",
      v$: useValidate(),
      idNumber: "",
      expirationDate: "",
      cvv: "",
      saveCard: true,
      showErrorMessage: false
    };
  },
  props: {
    error: {
      type: String,
      default: ''
    }
  },
  validations() {
    return {
      cardNumber: cardValidation.cardNumber,
      cvv: cardValidation.cvv,
      expirationDate: cardValidation.expirationDate,
      idNumber: cardValidation.idNumber,
    };
  },
  emits: ["close", "card-added"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async addNewCard() {
      this.showErrorMessage = false;
      const isValid = await this.v$.$validate();
      const formData = {
        save_tokef: this.expirationDate,
        save_taz: this.idNumber,
        save_card: this.cardNumber.replace(/\s/g, ""),
        save_cvv: this.cvv,
        is_default: false,
      };
      try {
        if (isValid) {
          if (this.saveCard) {
            await axiosInstance.post("/payment_methods/credit_card", formData);
            this.closeModal();
          }
          this.$emit("card-added", {...formData, saveCard: this.saveCard});
        }
      } catch (e) {
        this.showErrorMessage = true;
        console.error(e);
      }
    },
  },
};
</script>

<template>
  <div
      class="w-full h-full absolute bg-opacity-30 bg-black z-10 flex justify-center items-center"
  >
    <div class="bg-white custom-modal:h-auto h-[500px] custom-modal:w-auto w-[650px] rounded relative m-4">
      <div class="bg-primary-700 custom-modal:h-auto h-[100px] rounded-t flex justify-between">
        <div class="flex gap-4 custom-modal:text-sm text-2xl text-white w-full items-center pr-5">
          <div
              class="material-symbols-rounded rounded-full text-complementary-900 bg-complementary-600 h-10 w-10 text-center p-2"
          >
            credit_card
          </div>
          <div>הוספת כרטיס אשראי חדש</div>
        </div>
        <button
            class="material-symbols-rounded text-white m-5 h-fit"
            @click="closeModal"
        >
          close
        </button>
      </div>
      <div
          class="flex flex-row-reverse custom-modal:justify-center justify-between items-center  min-h-[330px] custom-modal:min-h-[250px]"
      >
        <div class="mt-8  flex custom-modal:hidden">
          <img
              alt="card"
              class="w-[300px] object-contain p-5"
              src="/src/assets/images/card.jpg"
          />
        </div>
        <div class="custom-modal:p-1 p-5">
          <input-default
              v-model="cardNumber"
              v-maska
              :error="v$.cardNumber.$error"
              :errorMessage="v$.cardNumber.$errors[0]?.$message"
              :label="'מספר אשראי'"
              :maxlength="19"
              autocomplete="cc-number"
              class="text-dir-ltr"
              data-maska="#### #### #### ####"
              type="text"
          >
            <template v-slot:left_icon>
              <span class="material-symbols-rounded text-grays-700 text-[20px]"
              >credit_card</span
              >
            </template>
          </input-default>
          <div class="flex flex-row-reverse justify-end gap-[20px]">
            <div class="flex w-[100px]">
              <input-default
                  v-model="cvv"
                  v-maska
                  :error="v$.cvv.$error"
                  :errorMessage="v$.cvv.$errors[0]?.$message"
                  :label="'CVV'"
                  :maxlength="4"
                  :placeholder="''"
                  :widthAuto="true"
                  autocomplete="cc-csc"
                  data-maska="####"
                  type="text"
              >
                <template v-slot:label_icon>
                  <div class="relative group">
                    <span
                        class="material-symbols-rounded text-grays-700 text-[16px]"
                    >error</span
                    >
                    <tooltip-cvv class="opacity-0 group-hover:opacity-100"/>
                  </div>
                </template>
              </input-default>
            </div>
            <div class="flex w-[180px]">
              <input-default
                  v-model="expirationDate"
                  v-maska
                  :error="v$.expirationDate.$error"
                  :errorMessage="v$.expirationDate.$errors[0]?.$message"
                  :label="'תוקף'"
                  :maxlength="5"
                  :widthAuto="true"
                  data-maska="##/##"
                  placeholder=""
                  type="text"
              >
              </input-default>
            </div>
          </div>
          <input-default
              v-model="idNumber"
              :error="v$.idNumber.$error"
              :errorMessage="v$.idNumber.$errors[0]?.$message"
              autocomplete="cc-number"
              label="תעודת זהות"
              type="number"
          >
          </input-default>
        </div>
      </div>
      <div v-if="showErrorMessage" class="absolute flex-row flex gap-1 right-[30px] bottom-[100px]">
        <span class="text-sm text-error">Invalid card data</span>
        <span class="text-sm material-symbols-rounded text-error">error</span>
      </div>
      <div v-else-if="error" class="absolute flex-row flex gap-1 right-[30px] bottom-[100px]">
        <span class="text-sm text-error">{{ error }}</span>
        <span class="text-sm material-symbols-rounded text-error">error</span>
      </div>
      <div
          class="ml-5 custom-modal:ml-2 mt-1 custom-modal:mt-2 custom-modal:m-2 flex-row-reverse flex gap-2 text-primary-700">
        <button-primary @click="addNewCard">לעדכן אמצעי תשלום</button-primary>
        <check-box v-model="saveCard">שמור כרטיס באמצעי התשלום</check-box>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>